import { render, staticRenderFns } from "./robot.vue?vue&type=template&id=02648299&scoped=true&"
import script from "./robot.vue?vue&type=script&lang=js&"
export * from "./robot.vue?vue&type=script&lang=js&"
import style0 from "./robot.vue?vue&type=style&index=0&lang=less&"
import style1 from "./robot.vue?vue&type=style&index=1&id=02648299&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02648299",
  null
  
)

export default component.exports